[
    {
      "Name": "Mechinagar",
      "Nepali": "मेची नगर",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "111,797",
      "Area_km2": "192.85"
    },
    {
      "Name": "Budhanilkantha",
      "Nepali": "बुढानिलकण्ठ",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "107,918",
      "Area_km2": "34.8"
    },
    {
      "Name": "Gokarneshwar",
      "Nepali": "गोकर्णेश्वर",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "107,351",
      "Area_km2": "58.5"
    },
    {
      "Name": "Bhimdatta",
      "Nepali": "भीमदत्त",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "104,599",
      "Area_km2": "171.8"
    },
    {
      "Name": "Birendranagar",
      "Nepali": "बीरेन्द्रनगर",
      "District": "Surkhet",
      "Province": "Karnali",
      "Population_2011": "100,458",
      "Area_km2": "245.06"
    },
    {
      "Name": "Tilottama",
      "Nepali": "तिलोत्तमा",
      "District": "Rupandehi",
      "Province": "Province No. 5",
      "Population_2011": "100,149",
      "Area_km2": "126.19"
    },
    {
      "Name": "Tokha",
      "Nepali": "टोखा",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "99,032",
      "Area_km2": "17.11"
    },
    {
      "Name": "Lahan",
      "Nepali": "लहान",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "91,766",
      "Area_km2": "167.17"
    },
    {
      "Name": "Triyuga",
      "Nepali": "त्रियुगा",
      "District": "Udayapur",
      "Province": "Province No. 1",
      "Population_2011": "87,557",
      "Area_km2": "547.43"
    },
    {
      "Name": "Chandragiri",
      "Nepali": "चन्द्रागिरी",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "85,198",
      "Area_km2": "43.92"
    },
    {
      "Name": "Madhyapur Thimi",
      "Nepali": "मध्यपुर थिमी",
      "District": "Bhaktapur",
      "Province": "Province No. 3",
      "Population_2011": "83,036",
      "Area_km2": "11.47"
    },
    {
      "Name": "Siraha",
      "Nepali": "सिरहा",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "82,531",
      "Area_km2": "94.2"
    },
    {
      "Name": "Birtamod",
      "Nepali": "विर्तामोड",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "81,878",
      "Area_km2": "78.24"
    },
    {
      "Name": "Bhaktapur",
      "Nepali": "भक्तपुर",
      "District": "Bhaktapur",
      "Province": "Province No. 3",
      "Population_2011": "81,728",
      "Area_km2": "6.89"
    },
    {
      "Name": "Tarakeshwar",
      "Nepali": "तारकेश्वर",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "81,443",
      "Area_km2": "54.95"
    },
    {
      "Name": "Tikapur",
      "Nepali": "टिकापुर",
      "District": "Kailali",
      "Province": "Sudurpashchim",
      "Population_2011": "80,690",
      "Area_km2": "118.33"
    },
    {
      "Name": "Sundar Haraincha",
      "Nepali": "सुन्दरहरैंचा",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "80,518",
      "Area_km2": "110.16"
    },
    {
      "Name": "Suryabinayak",
      "Nepali": "सूर्यविनायक",
      "District": "Bhaktapur",
      "Province": "Province No. 3",
      "Population_2011": "78,490",
      "Area_km2": "42.45"
    },
    {
      "Name": "Godawari",
      "Nepali": "गोदावरी",
      "District": "Lalitpur",
      "Province": "Province No. 3",
      "Population_2011": "78,301",
      "Area_km2": "96.11"
    },
    {
      "Name": "Godawari, Seti",
      "Nepali": "गोदावरी",
      "District": "Kailali",
      "Province": "Sudurpashchim",
      "Population_2011": "78,018",
      "Area_km2": "305.63"
    },
    {
      "Name": "Barahachhetra",
      "Nepali": "बराहक्षेत्र",
      "District": "Sunsari",
      "Province": "Province No. 1",
      "Population_2011": "77,408",
      "Area_km2": "222.09"
    },
    {
      "Name": "Kapilvastu",
      "Nepali": "कपिलवस्तु",
      "District": "Kapilvastu",
      "Province": "Province No. 5",
      "Population_2011": "76,394",
      "Area_km2": "136.91"
    },
    {
      "Name": "Ghodaghodi",
      "Nepali": "घोडाघोडी",
      "District": "Kailali",
      "Province": "Sudurpashchim",
      "Population_2011": "75,586",
      "Area_km2": "354.45"
    },
    {
      "Name": "Lamki Chuha",
      "Nepali": "लम्की चुहा",
      "District": "Kailali",
      "Province": "Sudurpashchim",
      "Population_2011": "75,425",
      "Area_km2": "225"
    },
    {
      "Name": "Banganga",
      "Nepali": "बाणगंगा",
      "District": "Kapilvastu",
      "Province": "Province No. 5",
      "Population_2011": "75,242",
      "Area_km2": "233.68"
    },
    {
      "Name": "Damak",
      "Nepali": "दमक",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "75,102",
      "Area_km2": "70.86"
    },
    {
      "Name": "Lumbini Sanskritik",
      "Nepali": "लुम्बिनी सांस्कृतिक",
      "District": "Rupandehi",
      "Province": "Province No. 5",
      "Population_2011": "72,497",
      "Area_km2": "112.21"
    },
    {
      "Name": "Chandrapur",
      "Nepali": "चन्द्रपुर",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "72,059",
      "Area_km2": "249.96"
    },
    {
      "Name": "Kohalpur",
      "Nepali": "कोहलपुर",
      "District": "Banke",
      "Province": "Province No. 5",
      "Population_2011": "70,647",
      "Area_km2": "184.26"
    },
    {
      "Name": "Vyas",
      "Nepali": "व्यास",
      "District": "Tanahun",
      "Province": "Gandaki",
      "Population_2011": "70,335",
      "Area_km2": "248"
    },
    {
      "Name": "Ratnanagar",
      "Nepali": "रत्ननगर",
      "District": "Chitwan",
      "Province": "Province No. 3",
      "Population_2011": "69,848",
      "Area_km2": "68.68"
    },
    {
      "Name": "Barahathwa",
      "Nepali": "बरहथवा",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "69,822",
      "Area_km2": "107.05"
    },
    {
      "Name": "Rajbiraj",
      "Nepali": "राजविराज",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "69,086[5]",
      "Area_km2": "55.64[5]"
    },
    {
      "Name": "Barbardiya",
      "Nepali": "बारबर्दिया",
      "District": "Bardiya",
      "Province": "Province No. 5",
      "Population_2011": "68,012",
      "Area_km2": "226.09"
    },
    {
      "Name": "Shivaraj",
      "Nepali": "शिवराज",
      "District": "Kapilvastu",
      "Province": "Province No. 5",
      "Population_2011": "66,781",
      "Area_km2": "284.07"
    },
    {
      "Name": "Gulariya",
      "Nepali": "गुलरिया",
      "District": "Bardiya",
      "Province": "Province No. 5",
      "Population_2011": "66,679",
      "Area_km2": "118.21"
    },
    {
      "Name": "Gaushala",
      "Nepali": "गौशाला",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "66,673",
      "Area_km2": "144.73"
    },
    {
      "Name": "Bardibas",
      "Nepali": "बर्दिबास",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "66,354",
      "Area_km2": "315.57"
    },
    {
      "Name": "Belbari",
      "Nepali": "बेलवारी",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "65,892",
      "Area_km2": "132.79"
    },
    {
      "Name": "Kirtipur",
      "Nepali": "किर्तिपुर",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "65,602",
      "Area_km2": "14.76"
    },
    {
      "Name": "Bhadrapur",
      "Nepali": "भद्रपुर",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "65,543",
      "Area_km2": "96.35"
    },
    {
      "Name": "Nagarjun",
      "Nepali": "नागार्जुन",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "65,420",
      "Area_km2": "29.85"
    },
    {
      "Name": "Dudhauli",
      "Nepali": "दुधौली",
      "District": "Sindhuli",
      "Province": "Province No. 3",
      "Population_2011": "65,302",
      "Area_km2": "390.39"
    },
    {
      "Name": "Kamalamai",
      "Nepali": "कमलामाई",
      "District": "Sindhuli",
      "Province": "Province No. 3",
      "Population_2011": "65,064",
      "Area_km2": "482.57"
    },
    {
      "Name": "Buddhabhumi",
      "Nepali": "बुद्धभूमी",
      "District": "Kapilvastu",
      "Province": "Province No. 5",
      "Population_2011": "64,949",
      "Area_km2": "366.67"
    },
    {
      "Name": "Shivasatakshi",
      "Nepali": "शिवसताक्षि",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "64,596",
      "Area_km2": "145.87"
    },
    {
      "Name": "Inaruwa",
      "Nepali": "ईनरुवा",
      "District": "Sunsari",
      "Province": "Province No. 1",
      "Population_2011": "63,593",
      "Area_km2": "77.92"
    },
    {
      "Name": "Siddharthanagar",
      "Nepali": "सिद्धार्थनगर",
      "District": "Rupandehi",
      "Province": "Province No. 5",
      "Population_2011": "63,483",
      "Area_km2": "36.03"
    },
    {
      "Name": "Pathari-Shanischare",
      "Nepali": "पथरी शनिश्चरे",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "62,440",
      "Area_km2": "79.81"
    },
    {
      "Name": "Kawasoti",
      "Nepali": "कावासोती",
      "District": "Nawalpur",
      "Province": "Gandaki",
      "Population_2011": "62,421",
      "Area_km2": "108.34"
    },
    {
      "Name": "Krishnanagar",
      "Nepali": "कृष्णनगर",
      "District": "Kapilvastu",
      "Province": "Province No. 5",
      "Population_2011": "62,370",
      "Area_km2": "96.66"
    },
    {
      "Name": "Mahalaxmi",
      "Nepali": "महालक्ष्मी",
      "District": "Lalitpur",
      "Province": "Province No. 3",
      "Population_2011": "62,172",
      "Area_km2": "26.51"
    },
    {
      "Name": "Kageshwari-Manohara",
      "Nepali": "कागेश्वरी मनोहरा",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "60,237",
      "Area_km2": "27.38"
    },
    {
      "Name": "Arjundhara",
      "Nepali": "अर्जुनधारा",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "60,204",
      "Area_km2": "109.86"
    },
    {
      "Name": "Ishwarpur",
      "Nepali": "ईश्वरपूर",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "59,986",
      "Area_km2": "163.83"
    },
    {
      "Name": "Rajapur",
      "Nepali": "राजापुर",
      "District": "Bardiya",
      "Province": "Province No. 5",
      "Population_2011": "59,553",
      "Area_km2": "127.08"
    },
    {
      "Name": "Ramgram",
      "Nepali": "रामग्राम",
      "District": "Parasi",
      "Province": "Province No. 5",
      "Population_2011": "59,455",
      "Area_km2": "128.32"
    },
    {
      "Name": "Lalbandi",
      "Nepali": "लालबन्दी",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "59,395",
      "Area_km2": "238.5"
    },
    {
      "Name": "Gaindakot",
      "Nepali": "गैडाकोट",
      "District": "Nawalpur",
      "Province": "Gandaki",
      "Population_2011": "58,836",
      "Area_km2": "159.93"
    },
    {
      "Name": "Jaleshwar",
      "Nepali": "जलेश्वर",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "58,549",
      "Area_km2": "44.26"
    },
    {
      "Name": "Nilkantha",
      "Nepali": "निलकण्ठ",
      "District": "Dhading",
      "Province": "Province No. 3",
      "Population_2011": "58,515",
      "Area_km2": "197.7"
    },
    {
      "Name": "Baglung",
      "Nepali": "बागलुङ",
      "District": "Baglung",
      "Province": "Gandaki",
      "Population_2011": "57,823",
      "Area_km2": "98.01"
    },
    {
      "Name": "Rapti",
      "Nepali": "राप्ती",
      "District": "Chitwan",
      "Province": "Province No. 3",
      "Population_2011": "57,107",
      "Area_km2": "212.31"
    },
    {
      "Name": "Suryodaya",
      "Nepali": "सूर्योदय",
      "District": "Ilam",
      "Province": "Province No. 1",
      "Population_2011": "56,691",
      "Area_km2": "252.52"
    },
    {
      "Name": "Krishnapur",
      "Nepali": "कृष्णपुर",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "56,643",
      "Area_km2": "252.75"
    },
    {
      "Name": "Duhabi",
      "Nepali": "दुहवी",
      "District": "Sunsari",
      "Province": "Province No. 1",
      "Population_2011": "56,269",
      "Area_km2": "73.67"
    },
    {
      "Name": "Katari",
      "Nepali": "कटारी",
      "District": "Udayapur",
      "Province": "Province No. 1",
      "Population_2011": "56,146",
      "Area_km2": "424.89"
    },
    {
      "Name": "Khairhani",
      "Nepali": "खैरहनी",
      "District": "Chitwan",
      "Province": "Province No. 3",
      "Population_2011": "56,094",
      "Area_km2": "85.55"
    },
    {
      "Name": "Bansgadhi",
      "Nepali": "बासगढी",
      "District": "Bardiya",
      "Province": "Province No. 5",
      "Population_2011": "55,875",
      "Area_km2": "206.08"
    },
    {
      "Name": "Sainamaina",
      "Nepali": "सैनामैना",
      "District": "Rupandehi",
      "Province": "Province No. 5",
      "Population_2011": "55,822",
      "Area_km2": "162.18"
    },
    {
      "Name": "Banepa",
      "Nepali": "बनेपा",
      "District": "Kavrepalanchok",
      "Province": "Province No. 3",
      "Population_2011": "55,628",
      "Area_km2": "55"
    },
    {
      "Name": "Changunarayan",
      "Nepali": "चाँगुनारायण",
      "District": "Bhaktapur",
      "Province": "Province No. 3",
      "Population_2011": "55,430",
      "Area_km2": "62.98"
    },
    {
      "Name": "Sunwal",
      "Nepali": "सुनवल",
      "District": "Parasi",
      "Province": "Province No. 5",
      "Population_2011": "55,424",
      "Area_km2": "139.1"
    },
    {
      "Name": "Bardghat",
      "Nepali": "बर्दघाट",
      "District": "Parasi",
      "Province": "Province No. 5",
      "Population_2011": "55,382",
      "Area_km2": "162.05"
    },
    {
      "Name": "Ratuwamai",
      "Nepali": "रतुवामाई",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "55,380",
      "Area_km2": "142.15"
    },
    {
      "Name": "Gauriganga",
      "Nepali": "गौरीगंगा",
      "District": "Kailali",
      "Province": "Sudurpashchim",
      "Population_2011": "55,314",
      "Area_km2": "244.44"
    },
    {
      "Name": "Maharajganj",
      "Nepali": "महाराजगंज",
      "District": "Kapilvastu",
      "Province": "Province No. 5",
      "Population_2011": "54,800",
      "Area_km2": "112.21"
    },
    {
      "Name": "Urlabari",
      "Nepali": "उर्लावारी",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "54,696",
      "Area_km2": "74.62"
    },
    {
      "Name": "Mahagadhimai",
      "Nepali": "महागढीमाई",
      "District": "Bara",
      "Province": "Province No. 2",
      "Population_2011": "54,474",
      "Area_km2": "55.32"
    },
    {
      "Name": "Bidur",
      "Nepali": "विदुर",
      "District": "Nuwakot",
      "Province": "Province No. 3",
      "Population_2011": "54,351",
      "Area_km2": "130.01"
    },
    {
      "Name": "Madhyabindu",
      "Nepali": "मध्यविन्दु",
      "District": "Nawalpur",
      "Province": "Gandaki",
      "Population_2011": "54,140",
      "Area_km2": "233.35"
    },
    {
      "Name": "Punarbas",
      "Nepali": "पुनर्वास",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "53,633",
      "Area_km2": "103.71"
    },
    {
      "Name": "Belauri",
      "Nepali": "बेलौरी",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "53,544",
      "Area_km2": "123.37"
    },
    {
      "Name": "Devdaha",
      "Nepali": "देवदह",
      "District": "Rupandehi",
      "Province": "Province No. 5",
      "Population_2011": "53,523",
      "Area_km2": "136.95"
    },
    {
      "Name": "Gauradaha",
      "Nepali": "गौरादह",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "53,033",
      "Area_km2": "149.86"
    },
    {
      "Name": "Rangeli",
      "Nepali": "रंगेली",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "52,013",
      "Area_km2": "111.78"
    },
    {
      "Name": "Bhajani",
      "Nepali": "भजनी",
      "District": "Kailali",
      "Province": "Sudurpashchim",
      "Population_2011": "51,845",
      "Area_km2": "176.25"
    },
    {
      "Name": "Ramdhuni",
      "Nepali": "रामधुनी",
      "District": "Sunsari",
      "Province": "Province No. 1",
      "Population_2011": "51,752",
      "Area_km2": "91.69"
    },
    {
      "Name": "Waling",
      "Nepali": "वालिङ",
      "District": "Syangja",
      "Province": "Gandaki",
      "Population_2011": "51,143",
      "Area_km2": "128.4"
    },
    {
      "Name": "Golbazar",
      "Nepali": "गोलबजार",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "51,137",
      "Area_km2": "111.94"
    },
    {
      "Name": "Sunawarshi",
      "Nepali": "सुनवर्षी",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "50,758",
      "Area_km2": "106.4"
    },
    {
      "Name": "Garuda",
      "Nepali": "गरुडा",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "50,481",
      "Area_km2": "44.46"
    },
    {
      "Name": "Tansen",
      "Nepali": "तानसेन",
      "District": "Palpa",
      "Province": "Province No. 5",
      "Population_2011": "50,405",
      "Area_km2": "109.8"
    },
    {
      "Name": "Mirchaiya",
      "Nepali": "मिर्चैया",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "50,079",
      "Area_km2": "91.97"
    },
    {
      "Name": "Simraungadh",
      "Nepali": "सिम्रोनगढ",
      "District": "Bara",
      "Province": "Province No. 2",
      "Population_2011": "49,939",
      "Area_km2": "42.65"
    },
    {
      "Name": "Manara Shisawa",
      "Nepali": "मनरा शिसवा",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "49,692",
      "Area_km2": "49.73"
    },
    {
      "Name": "Bedkot",
      "Nepali": "वेदकोट",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "49,479",
      "Area_km2": "159.92"
    },
    {
      "Name": "Kalyanpur",
      "Nepali": "कल्याणपुर",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "49,288",
      "Area_km2": "76.81"
    },
    {
      "Name": "Gorkha",
      "Nepali": "गोरखा",
      "District": "Gorkha",
      "Province": "Gandaki",
      "Population_2011": "49,272",
      "Area_km2": "131.86"
    },
    {
      "Name": "Phidim",
      "Nepali": "फिदिम",
      "District": "Pancthar",
      "Province": "Province No. 1",
      "Population_2011": "49,201",
      "Area_km2": "192.5"
    },
    {
      "Name": "Chaudandigadhi",
      "Nepali": "चौदण्डीगढी",
      "District": "Udayapur",
      "Province": "Province No. 1",
      "Population_2011": "48,578",
      "Area_km2": "283.78"
    },
    {
      "Name": "Ilam",
      "Nepali": "इलाम",
      "District": "Ilam",
      "Province": "Province No. 1",
      "Population_2011": "48,536",
      "Area_km2": "173.32"
    },
    {
      "Name": "Shuklagandaki",
      "Nepali": "शुक्लागण्डकी",
      "District": "Tanahun",
      "Province": "Gandaki",
      "Population_2011": "48,456",
      "Area_km2": "165"
    },
    {
      "Name": "Godaita",
      "Nepali": "गोडैता",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "47,687",
      "Area_km2": "48.62"
    },
    {
      "Name": "Lamahi",
      "Nepali": "लमही",
      "District": "Dang",
      "Province": "Province No. 5",
      "Population_2011": "47,655",
      "Area_km2": "326.66"
    },
    {
      "Name": "Dhangadimai",
      "Nepali": "धनगढीमाई",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "47,449",
      "Area_km2": "159.51"
    },
    {
      "Name": "Diktel–Rupakot–Majuwagadhi",
      "Nepali": "दिक्तेल–रुपाकोट–मजुवागढी",
      "District": "Khotang",
      "Province": "Province No. 1",
      "Population_2011": "46,903",
      "Area_km2": "246.51"
    },
    {
      "Name": "Shuklaphanta",
      "Nepali": "शुक्लाफाँटा",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "46,834",
      "Area_km2": "162.57"
    },
    {
      "Name": "Bhangaha",
      "Nepali": "भँगाहा",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "46,754",
      "Area_km2": "77.21"
    },
    {
      "Name": "Paunauti",
      "Nepali": "पनौती",
      "District": "Kavrepalanchowk",
      "Province": "Province No. 3",
      "Population_2011": "46,595",
      "Area_km2": "118"
    },
    {
      "Name": "Gujara",
      "Nepali": "गुजरा",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "46,592",
      "Area_km2": "150.33"
    },
    {
      "Name": "Malangwa",
      "Nepali": "मलङ्गवा",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "46,516",
      "Area_km2": "30.44"
    },
    {
      "Name": "Chautara Sangachokgadhi",
      "Nepali": "चौतारा साँगाचोकगढी",
      "District": "Sindhupalchowk",
      "Province": "Province No. 3",
      "Population_2011": "46,501",
      "Area_km2": "165.25"
    },
    {
      "Name": "Madhuwan",
      "Nepali": "मधुवन",
      "District": "Bardiya",
      "Province": "Province No. 5",
      "Population_2011": "46,437",
      "Area_km2": "129.73"
    },
    {
      "Name": "Sabaila",
      "Nepali": "सवैला",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "45,879",
      "Area_km2": "64.47"
    },
    {
      "Name": "Bhanu",
      "Nepali": "भानु",
      "District": "Tanahun",
      "Province": "Gandaki",
      "Population_2011": "45,792",
      "Area_km2": "184"
    },
    {
      "Name": "Hanumannagar Kankalini",
      "Nepali": "हनुमाननगर कंकालिनी",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "45,734",
      "Area_km2": "118.19"
    },
    {
      "Name": "Dhanushadham",
      "Nepali": "धनुषाधाम",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "45,665",
      "Area_km2": "91.64"
    },
    {
      "Name": "Manthali",
      "Nepali": "मन्थली",
      "District": "Ramechhap",
      "Province": "Province No. 3",
      "Population_2011": "45,416",
      "Area_km2": "211.78"
    },
    {
      "Name": "Khadak",
      "Nepali": "खडक",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "45,367",
      "Area_km2": "93.77"
    },
    {
      "Name": "Melamchi",
      "Nepali": "मेलम्ची",
      "District": "Sindhupalchowk",
      "Province": "Province No. 3",
      "Population_2011": "45,343",
      "Area_km2": "158.17"
    },
    {
      "Name": "Balara",
      "Nepali": "बलरा",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "45,194",
      "Area_km2": "48.55"
    },
    {
      "Name": "Mithila",
      "Nepali": "मिथिला",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "45,164",
      "Area_km2": "187.93"
    },
    {
      "Name": "Putalibazar",
      "Nepali": "पुतलीबजार",
      "District": "Syangja",
      "Province": "Gandaki",
      "Population_2011": "44,876",
      "Area_km2": "147.21"
    },
    {
      "Name": "Dakneshwari",
      "Nepali": "दक्नेश्वारी",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "44,782",
      "Area_km2": "69.11"
    },
    {
      "Name": "Thakurbaba",
      "Nepali": "ठाकुरबाबा",
      "District": "Bardiya",
      "Province": "Province No. 5",
      "Population_2011": "44,361",
      "Area_km2": "104.57"
    },
    {
      "Name": "Surunga",
      "Nepali": "सुरुङ्‍गा",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "44,221",
      "Area_km2": "107.04"
    },
    {
      "Name": "Hariwan",
      "Nepali": "हरिवन",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "43,928",
      "Area_km2": "86.12"
    },
    {
      "Name": "Gurbhakot",
      "Nepali": "गुर्भाकोट",
      "District": "Surkhet",
      "Province": "Karnali",
      "Population_2011": "43,765",
      "Area_km2": "228.62"
    },
    {
      "Name": "Sitganga",
      "Nepali": "सितगंगा",
      "District": "Arghakhanchi",
      "Province": "Province No. 5",
      "Population_2011": "43,373",
      "Area_km2": "610.43"
    },
    {
      "Name": "Bodebarsain",
      "Nepali": "बोदेबरसाईन",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "43,229",
      "Area_km2": "58.93"
    },
    {
      "Name": "Kolhabi",
      "Nepali": "कोल्हवी",
      "District": "Bara",
      "Province": "Province No. 2",
      "Population_2011": "43,036",
      "Area_km2": "157.4"
    },
    {
      "Name": "Shahidnagar",
      "Nepali": "शहिद नगर",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "43,007",
      "Area_km2": "57.37"
    },
    {
      "Name": "Brindaban",
      "Nepali": "बृन्दावन",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "42,735",
      "Area_km2": "95.4"
    },
    {
      "Name": "Devchuli",
      "Nepali": "देवचुली",
      "District": "Nawalpur",
      "Province": "Gandaki",
      "Population_2011": "42,603",
      "Area_km2": "112.72"
    },
    {
      "Name": "Kshireshwarnath",
      "Nepali": "क्षिरेश्वरनाथ",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "42,541",
      "Area_km2": "50.85"
    },
    {
      "Name": "Belaka",
      "Nepali": "वेलका",
      "District": "Udayapur",
      "Province": "Province No. 1",
      "Population_2011": "42,356",
      "Area_km2": "344.73"
    },
    {
      "Name": "Balawa",
      "Nepali": "बलवा",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "42,341",
      "Area_km2": "44.07"
    },
    {
      "Name": "Kabilasi",
      "Nepali": "कविलासी",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "42,336",
      "Area_km2": "48.11"
    },
    {
      "Name": "Kalika",
      "Nepali": "कालिका",
      "District": "Chitwan",
      "Province": "Province No. 3",
      "Population_2011": "41,742",
      "Area_km2": "149.08"
    },
    {
      "Name": "Thaha",
      "Nepali": "थाहा",
      "District": "Makawanpur",
      "Province": "Province No. 3",
      "Population_2011": "41,623",
      "Area_km2": "191.12"
    },
    {
      "Name": "Dullu",
      "Nepali": "दुल्लु",
      "District": "Dailekh",
      "Province": "Karnali",
      "Population_2011": "41,540",
      "Area_km2": "156.77"
    },
    {
      "Name": "Ishnath",
      "Nepali": "ईशनाथ",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "41,435",
      "Area_km2": "35.18"
    },
    {
      "Name": "Bheriganga",
      "Nepali": "भेरीगंगा",
      "District": "Surkhet",
      "Province": "Karnali",
      "Population_2011": "41,407",
      "Area_km2": "256.2"
    },
    {
      "Name": "Sandhikharka",
      "Nepali": "सन्धिखर्क",
      "District": "Arghakhanchi",
      "Province": "Province No. 5",
      "Population_2011": "41,079",
      "Area_km2": "129.42"
    },
    {
      "Name": "Rajpur",
      "Nepali": "राजपुर",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "41,078",
      "Area_km2": "31.41"
    },
    {
      "Name": "Gadhimai",
      "Nepali": "गढीमाई",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "40,410",
      "Area_km2": "49.44"
    },
    {
      "Name": "Bagmati",
      "Nepali": "बागमती",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "40,399",
      "Area_km2": "101.18"
    },
    {
      "Name": "Kankai",
      "Nepali": "कन्काई",
      "District": "Jhapa",
      "Province": "Province No. 1",
      "Population_2011": "40,141",
      "Area_km2": "80.98"
    },
    {
      "Name": "Belkotgadhi",
      "Nepali": "बेलकोटगढी",
      "District": "Nuwakot",
      "Province": "Province No. 3",
      "Population_2011": "39,888",
      "Area_km2": "155.6"
    },
    {
      "Name": "Bahudarmai",
      "Nepali": "बहुदरमाई",
      "District": "Parsa",
      "Province": "Province No. 2",
      "Population_2011": "39,673",
      "Area_km2": "31.55"
    },
    {
      "Name": "Kushma",
      "Nepali": "कुश्मा",
      "District": "Parbat",
      "Province": "Gandaki",
      "Population_2011": "39,600",
      "Area_km2": "93.18"
    },
    {
      "Name": "Loharpatti",
      "Nepali": "लोहरपट्टी",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "39,579",
      "Area_km2": "50.06"
    },
    {
      "Name": "Besisahar",
      "Nepali": "बेसीशहर",
      "District": "Lamjung",
      "Province": "Gandaki",
      "Population_2011": "39,356",
      "Area_km2": "127.64"
    },
    {
      "Name": "Mahakali",
      "Nepali": "माहाकाली",
      "District": "Kanchanpur",
      "Province": "Sudurpashchim",
      "Population_2011": "39,253",
      "Area_km2": "56.84"
    },
    {
      "Name": "Purchaundi",
      "Nepali": "पुर्चौडी",
      "District": "Baitadi",
      "Province": "Sudurpashchim",
      "Population_2011": "39,174",
      "Area_km2": "198.52"
    },
    {
      "Name": "Hansapur",
      "Nepali": "हंसपुर",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "39,145",
      "Area_km2": "48.71"
    },
    {
      "Name": "Kamala",
      "Nepali": "कमला",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "38,877",
      "Area_km2": "65.85"
    },
    {
      "Name": "Pyuthan",
      "Nepali": "प्यूठान",
      "District": "Pyuthan",
      "Province": "Province No. 5",
      "Population_2011": "38,449",
      "Area_km2": "128.96"
    },
    {
      "Name": "Katahariya",
      "Nepali": "कटहरीया",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "38,413",
      "Area_km2": "40.69"
    },
    {
      "Name": "Palungtar",
      "Nepali": "पालुङटार",
      "District": "Gorkha",
      "Province": "Gandaki",
      "Population_2011": "38,174",
      "Area_km2": "158.62"
    },
    {
      "Name": "Parsagadhi",
      "Nepali": "पर्सागढी",
      "District": "Parsa",
      "Province": "Province No. 2",
      "Population_2011": "38,067",
      "Area_km2": "99.69"
    },
    {
      "Name": "Shambhunath",
      "Nepali": "शम्भुनाथ",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "38,018",
      "Area_km2": "108.71"
    },
    {
      "Name": "Panchkhal",
      "Nepali": "पाँचखाल",
      "District": "Kavrepalanchok",
      "Province": "Province No. 3",
      "Population_2011": "37,997",
      "Area_km2": "103"
    },
    {
      "Name": "Madi",
      "Nepali": "माडी",
      "District": "Chitwan",
      "Province": "Province No. 3",
      "Population_2011": "37,683",
      "Area_km2": "218.24"
    },
    {
      "Name": "Sukhipur",
      "Nepali": "सुखीपुर",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "37,592",
      "Area_km2": "54.78"
    },
    {
      "Name": "Paroha",
      "Nepali": "परोहा",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "37,453",
      "Area_km2": "37.45"
    },
    {
      "Name": "Haripur",
      "Nepali": "हरिपुर",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "37,351",
      "Area_km2": "66.86"
    },
    {
      "Name": "Ganeshman Charnath",
      "Nepali": "गणेशमान चारनाथ",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "37,300",
      "Area_km2": "244.31"
    },
    {
      "Name": "Galyang",
      "Nepali": "गल्याङ",
      "District": "Syangja",
      "Province": "Gandaki",
      "Population_2011": "36,967",
      "Area_km2": "122.71"
    },
    {
      "Name": "Dhankuta",
      "Nepali": "धनकुटा",
      "District": "Dhankuta",
      "Province": "Province No. 1",
      "Population_2011": "36,619",
      "Area_km2": "111"
    },
    {
      "Name": "Phatuwa Bijayapur",
      "Nepali": "फतुवाबिजयपुर",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "36,533",
      "Area_km2": "65.24"
    },
    {
      "Name": "Baudhimai",
      "Nepali": "बौधीमाई",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "36,265",
      "Area_km2": "34.343"
    },
    {
      "Name": "Bangad Kupinde",
      "Nepali": "बनगाड कुपिण्डे",
      "District": "Salyan",
      "Province": "Karnali",
      "Population_2011": "36,052",
      "Area_km2": "338.21"
    },
    {
      "Name": "Haripurwa",
      "Nepali": "हरिपुर्वा",
      "District": "Sarlahi",
      "Province": "Province No. 2",
      "Population_2011": "36,042",
      "Area_km2": "30.50"
    },
    {
      "Name": "Rampur",
      "Nepali": "रामपुर",
      "District": "Palpa",
      "Province": "Province No. 5",
      "Population_2011": "35,396",
      "Area_km2": "123.34"
    },
    {
      "Name": "Chhedagad",
      "Nepali": "छेडागाड",
      "District": "Jajarkot",
      "Province": "Karnali",
      "Population_2011": "35,295",
      "Area_km2": "284.2"
    },
    {
      "Name": "Kanchanrup",
      "Nepali": "कञ्चनरूप",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "35,238",
      "Area_km2": "117.34"
    },
    {
      "Name": "Parashuram",
      "Nepali": "परशुराम",
      "District": "Dadeldhura",
      "Province": "Sudurpashchim",
      "Population_2011": "34,983",
      "Area_km2": "414.07"
    },
    {
      "Name": "Nagarain",
      "Nepali": "नगराईन",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "35,630",
      "Area_km2": "39.00"
    },
    {
      "Name": "Dasharathchand",
      "Nepali": "दशरथचन्द",
      "District": "Baitadi",
      "Province": "Sudurpashchim",
      "Population_2011": "34,575",
      "Area_km2": "135.15"
    },
    {
      "Name": "Nijgadh",
      "Nepali": "निजगढ",
      "District": "Bara",
      "Province": "Province No. 2",
      "Population_2011": "35,335",
      "Area_km2": "289.43"
    },
    {
      "Name": "Madhav Narayan",
      "Nepali": "माधव नारायण",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "35,175",
      "Area_km2": "48.53"
    },
    {
      "Name": "Gaur",
      "Nepali": "गौर",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "34,937",
      "Area_km2": "21.53"
    },
    {
      "Name": "Pachrauta",
      "Nepali": "पचरौता",
      "District": "Bara",
      "Province": "Province No. 2",
      "Population_2011": "34,175",
      "Area_km2": "44.01"
    },
    {
      "Name": "Bagchaur",
      "Nepali": "बागचौर",
      "District": "Salyan",
      "Province": "Karnali",
      "Population_2011": "34,118",
      "Area_km2": "163.14"
    },
    {
      "Name": "Sanphebagar",
      "Nepali": "साफेबगर",
      "District": "Achham",
      "Province": "Sudurpashchim",
      "Population_2011": "33,788",
      "Area_km2": "166.71"
    },
    {
      "Name": "Shaarda",
      "Nepali": "शारदा",
      "District": "Salyan",
      "Province": "Karnali",
      "Population_2011": "33,730",
      "Area_km2": "198.34"
    },
    {
      "Name": "Aathabiskot",
      "Nepali": "अाठबिसकाेट",
      "District": "Rukum West",
      "Province": "Karnali",
      "Population_2011": "33,601",
      "Area_km2": "560.34"
    },
    {
      "Name": "Mithila Bihari",
      "Nepali": "मिथिला बिहारी",
      "District": "Dhanusa",
      "Province": "Province No. 2",
      "Population_2011": "33,521",
      "Area_km2": "37.6"
    },
    {
      "Name": "Bheri",
      "Nepali": "भेरी",
      "District": "Jajarkot",
      "Province": "Karnali",
      "Population_2011": "33,515",
      "Area_km2": "219.77"
    },
    {
      "Name": "Beni",
      "Nepali": "बेनी",
      "District": "Myagdi",
      "Province": "Gandaki",
      "Population_2011": "33,498",
      "Area_km2": "76.57"
    },
    {
      "Name": "Bungal",
      "Nepali": "बुंगल",
      "District": "Bajhang",
      "Province": "Sudurpashchim",
      "Population_2011": "33,224",
      "Area_km2": "447.59"
    },
    {
      "Name": "Galkot",
      "Nepali": "गल्कोट",
      "District": "Baglung",
      "Province": "Gandaki",
      "Population_2011": "33,097",
      "Area_km2": "194.39"
    },
    {
      "Name": "Dipayal Silgadhi",
      "Nepali": "दिपायल सिलगढी",
      "District": "Doti",
      "Province": "Sudurpashchim",
      "Population_2011": "32,941",
      "Area_km2": "126.62"
    },
    {
      "Name": "Musikot",
      "Nepali": "मुसिकोट",
      "District": "Western Rukum",
      "Province": "Karnali",
      "Population_2011": "32,939",
      "Area_km2": "136.06"
    },
    {
      "Name": "Deumai",
      "Nepali": "देउमाई",
      "District": "Ilam",
      "Province": "Province No. 1",
      "Population_2011": "32,927",
      "Area_km2": "191.63"
    },
    {
      "Name": "Pokhariya",
      "Nepali": "पोखरिया",
      "District": "Parsa",
      "Province": "Province No. 2",
      "Population_2011": "32,885",
      "Area_km2": "32.47"
    },
    {
      "Name": "Musikot",
      "Nepali": "मुसिकोट",
      "District": "Gulmi",
      "Province": "Province No. 5",
      "Population_2011": "32,802",
      "Area_km2": "114.74"
    },
    {
      "Name": "Rolpa",
      "Nepali": "रोल्पा",
      "District": "Rolpa",
      "Province": "Province No. 5",
      "Population_2011": "32,759",
      "Area_km2": "270.42"
    },
    {
      "Name": "Mandandeupur",
      "Nepali": "मण्डनदेउपुर",
      "District": "Kavrepalanchok",
      "Province": "Province No. 3",
      "Population_2011": "32,659",
      "Area_km2": "89"
    },
    {
      "Name": "Bhumikasthan",
      "Nepali": "भूमिकास्थान",
      "District": "Arghakhanchi",
      "Province": "Province No. 5",
      "Population_2011": "32,640",
      "Area_km2": "159.13"
    },
    {
      "Name": "Mai",
      "Nepali": "माई",
      "District": "Ilam",
      "Province": "Province No. 1",
      "Population_2011": "32,576",
      "Area_km2": "246.11"
    },
    {
      "Name": "Resunga",
      "Nepali": "रेसुङ्गा",
      "District": "Gulmi",
      "Province": "Province No. 5",
      "Population_2011": "32,545",
      "Area_km2": "83.74"
    },
    {
      "Name": "Mangalsen",
      "Nepali": "मंगलसेन",
      "District": "Achham",
      "Province": "Sudurpashchim",
      "Population_2011": "32,331",
      "Area_km2": "220.14"
    },
    {
      "Name": "Bideha",
      "Nepali": "विदेह",
      "District": "Dhanusha",
      "Province": "Province No. 2",
      "Population_2011": "32,266",
      "Area_km2": "45.51"
    },
    {
      "Name": "Panchapuri",
      "Nepali": "पञ्चपुरी",
      "District": "Surkhet",
      "Province": "Karnali",
      "Population_2011": "32,231",
      "Area_km2": "329.9"
    },
    {
      "Name": "Dhulikhel",
      "Nepali": "धुलिखेल",
      "District": "Kavrepalanchowk",
      "Province": "Province No. 3",
      "Population_2011": "32,162",
      "Area_km2": "55"
    },
    {
      "Name": "Dewahi Gonahi",
      "Nepali": "देवाही गोनाही",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "32,146",
      "Area_km2": "33.99"
    },
    {
      "Name": "Letang Bhogateni",
      "Nepali": "लेटाङ",
      "District": "Morang",
      "Province": "Province No. 1",
      "Population_2011": "32,053",
      "Area_km2": "219.23"
    },
    {
      "Name": "Shikhar",
      "Nepali": "शिखर",
      "District": "Doti",
      "Province": "Sudurpashchim",
      "Population_2011": "31,801",
      "Area_km2": "285.37"
    },
    {
      "Name": "Aurahi",
      "Nepali": "औरही",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "31,751",
      "Area_km2": "35.76"
    },
    {
      "Name": "Shadanand",
      "Nepali": "षडानन्द",
      "District": "Bhojpur",
      "Province": "Province No. 1",
      "Population_2011": "31,610",
      "Area_km2": "241.15"
    },
    {
      "Name": "Bhimeshwar",
      "Nepali": "भीमेश्वर",
      "District": "Dolakha",
      "Province": "Province No. 3",
      "Population_2011": "31,480",
      "Area_km2": "132.5"
    },
    {
      "Name": "Jaimini",
      "Nepali": "जैमिनी",
      "District": "Baglung",
      "Province": "Gandaki",
      "Population_2011": "31,430",
      "Area_km2": "118.71"
    },
    {
      "Name": "Bhimad",
      "Nepali": "भिमाद",
      "District": "Tanahun",
      "Province": "Gandaki",
      "Population_2011": "31,362",
      "Area_km2": "129"
    },
    {
      "Name": "Rajdevi",
      "Nepali": "राजदेवी",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "31,292",
      "Area_km2": "28.21"
    },
    {
      "Name": "Khandbari",
      "Nepali": "खादँवारी",
      "District": "Sankhuwasabha",
      "Province": "Province No. 1",
      "Population_2011": "31,177",
      "Area_km2": "122.78"
    },
    {
      "Name": "Dhunibeshi",
      "Nepali": "धुनीबेंशी",
      "District": "Dhading",
      "Province": "Province No. 3",
      "Population_2011": "31,029",
      "Area_km2": "96.3"
    },
    {
      "Name": "Matihani",
      "Nepali": "मटिहानी",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "31,026",
      "Area_km2": "29.02"
    },
    {
      "Name": "Karjanha",
      "Nepali": "कर्जन्हा",
      "District": "Siraha",
      "Province": "Province No. 2",
      "Population_2011": "30,965",
      "Area_km2": "76.84"
    },
    {
      "Name": "Swargadwari",
      "Nepali": "स्वर्गद्वारी",
      "District": "Pyuthan",
      "Province": "Province No. 5",
      "Population_2011": "30,940",
      "Area_km2": "224.7"
    },
    {
      "Name": "Patan",
      "Nepali": "पाटन",
      "District": "Baitadi",
      "Province": "Sudurpashchim",
      "Population_2011": "30,435",
      "Area_km2": "219.26"
    },
    {
      "Name": "Lekbeshi",
      "Nepali": "लेकबेशी",
      "District": "Surkhet",
      "Province": "Karnali",
      "Population_2011": "30,295",
      "Area_km2": "180.92"
    },
    {
      "Name": "Ramgopalpur",
      "Nepali": "रामगोपालपुर",
      "District": "Mahottari",
      "Province": "Province No. 2",
      "Population_2011": "29,612",
      "Area_km2": "39.58"
    },
    {
      "Name": "Halesi Tuwachung",
      "Nepali": "हलेसी तुवाचुङ",
      "District": "Khotang",
      "Province": "Province No. 1",
      "Population_2011": "29,532",
      "Area_km2": "280.17"
    },
    {
      "Name": "Namobuddha",
      "Nepali": "नमोबुद्ध",
      "District": "Kavrepalanchok",
      "Province": "Province No. 3",
      "Population_2011": "29,519",
      "Area_km2": "102"
    },
    {
      "Name": "Aathabis",
      "Nepali": "आठबीस",
      "District": "Dailekh",
      "Province": "Karnali",
      "Population_2011": "29,227",
      "Area_km2": "168"
    },
    {
      "Name": "Ramechhap",
      "Nepali": "रामेछाप",
      "District": "Ramechhap",
      "Province": "Province No. 3",
      "Population_2011": "28,612",
      "Area_km2": "202.45"
    },
    {
      "Name": "Siddhicharan",
      "Nepali": "सिद्दिचरण",
      "District": "Okhaldhunga",
      "Province": "Province No. 1",
      "Population_2011": "28,374",
      "Area_km2": "167.88"
    },
    {
      "Name": "Panchadewal Binayak",
      "Nepali": "पञ्चदेवल विनायक",
      "District": "Achham",
      "Province": "Sudurpashchim",
      "Population_2011": "27,485",
      "Area_km2": "147.75"
    },
    {
      "Name": "Chaurjahari",
      "Nepali": "चौरजहारी",
      "District": "Rukum West",
      "Province": "Karnali",
      "Population_2011": "27,438",
      "Area_km2": "107.38"
    },
    {
      "Name": "Chainpur",
      "Nepali": "चैनपुर",
      "District": "Sankhuwasabha",
      "Province": "Province No. 1",
      "Population_2011": "27,308",
      "Area_km2": "223.69"
    },
    {
      "Name": "Bhojpur",
      "Nepali": "भोजपुर",
      "District": "Bhojpur",
      "Province": "Province No. 1",
      "Population_2011": "27,204",
      "Area_km2": "159.51"
    },
    {
      "Name": "Narayan",
      "Nepali": "नारायण",
      "District": "Dailekh",
      "Province": "Karnali",
      "Population_2011": "27,037",
      "Area_km2": "110.63"
    },
    {
      "Name": "Sundarbazar",
      "Nepali": "सुन्दरबजार",
      "District": "Lamjung",
      "Province": "Gandaki",
      "Population_2011": "26,861",
      "Area_km2": "72.05"
    },
    {
      "Name": "Barhabise",
      "Nepali": "बाह्रविसे",
      "District": "Sindhupalchowk",
      "Province": "Province No. 3",
      "Population_2011": "26,700",
      "Area_km2": "96.73"
    },
    {
      "Name": "Maulapur",
      "Nepali": "मौलापुर",
      "District": "Rautahat",
      "Province": "Province No. 2",
      "Population_2011": "26,431",
      "Area_km2": "34.75"
    },
    {
      "Name": "Taplejung(Phungling)",
      "Nepali": "फुङलिङ",
      "District": "Taplejung",
      "Province": "Province No. 1",
      "Population_2011": "26,406",
      "Area_km2": "125.57"
    },
    {
      "Name": "Dhorpatan",
      "Nepali": "ढोरपाटन",
      "District": "Baglung",
      "Province": "Gandaki",
      "Population_2011": "26,215",
      "Area_km2": "222.85"
    },
    {
      "Name": "Chamunda Bindrasaini",
      "Nepali": "चामुण्डा विन्द्रासैनी",
      "District": "Dailekh",
      "Province": "Karnali",
      "Population_2011": "26,149",
      "Area_km2": "90.6"
    },
    {
      "Name": "Chapakot",
      "Nepali": "चापाकोट",
      "District": "Syangja",
      "Province": "Gandaki",
      "Population_2011": "26,042",
      "Area_km2": "120.59"
    },
    {
      "Name": "Nalgad",
      "Nepali": "नलगाड",
      "District": "Jajarkot",
      "Province": "Karnali",
      "Population_2011": "25,597",
      "Area_km2": "387.44"
    },
    {
      "Name": "Bhirkot",
      "Nepali": "भिरकोट",
      "District": "Syangja",
      "Province": "Gandaki",
      "Population_2011": "25,583",
      "Area_km2": "78.23"
    },
    {
      "Name": "Shankharapur",
      "Nepali": "शङ्खरापुर",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "25,338",
      "Area_km2": "60.21"
    },
    {
      "Name": "Mahalaxmi",
      "Nepali": "महालक्ष्मी",
      "District": "Dhankuta",
      "Province": "Province No. 1",
      "Population_2011": "24,800",
      "Area_km2": "129.39"
    },
    {
      "Name": "Phalewas",
      "Nepali": "फलेवास",
      "District": "Parbat",
      "Province": "Gandaki",
      "Population_2011": "24,687",
      "Area_km2": "85.7"
    },
    {
      "Name": "Dakshinkali",
      "Nepali": "दक्षिणकाली",
      "District": "Kathmandu",
      "Province": "Province No. 3",
      "Population_2011": "24,296",
      "Area_km2": "42.68"
    },
    {
      "Name": "Kamalbazar",
      "Nepali": "कमलबजार",
      "District": "Achham",
      "Province": "Sudurpashchim",
      "Population_2011": "23,738",
      "Area_km2": "120.78"
    },
    {
      "Name": "Madhya Nepal",
      "Nepali": "मध्यनेपाल",
      "District": "Lamjung",
      "Province": "Gandaki",
      "Population_2011": "23,385",
      "Area_km2": "113.86"
    },
    {
      "Name": "Melauli",
      "Nepali": "मेलौली",
      "District": "Baitadi",
      "Province": "Sudurpashchim",
      "Population_2011": "22,545",
      "Area_km2": "119.43"
    },
    {
      "Name": "Jaya Prithvi",
      "Nepali": "जयपृथ्वी",
      "District": "Bajhang",
      "Province": "Sudurpashchim",
      "Population_2011": "22,191",
      "Area_km2": "166.79"
    },
    {
      "Name": "Pakhribas",
      "Nepali": "पाख्रिवास",
      "District": "Dhankuta",
      "Province": "Province No. 1",
      "Population_2011": "22,078",
      "Area_km2": "144.29"
    },
    {
      "Name": "Shailyashikhar",
      "Nepali": "शैल्यशिखर",
      "District": "Darchula",
      "Province": "Sudurpashchim",
      "Population_2011": "22,060",
      "Area_km2": "117.81"
    },
    {
      "Name": "Budhiganga",
      "Nepali": "बुढीगंगा",
      "District": "Bajura",
      "Province": "Sudurpashchim",
      "Population_2011": "21,677",
      "Area_km2": "59.2"
    },
    {
      "Name": "Amargadhi",
      "Nepali": "अमरगढी",
      "District": "Dadeldhura",
      "Province": "Sudurpashchim",
      "Population_2011": "21,245",
      "Area_km2": "139.33"
    },
    {
      "Name": "Mahakali",
      "Nepali": "महाकाली",
      "District": "Darchula",
      "Province": "Sudurpashchim",
      "Population_2011": "21,231",
      "Area_km2": "135.11"
    },
    {
      "Name": "Saptakoshi",
      "Nepali": "सप्तकोशी",
      "District": "Saptari",
      "Province": "Province No. 2",
      "Population_2011": "21,131",
      "Area_km2": "60.25"
    },
    {
      "Name": "Solu Dudhkunda",
      "Nepali": "सोलुदुधकुण्ड",
      "District": "Solukhumbu",
      "Province": "Province No. 1",
      "Population_2011": "20,399",
      "Area_km2": "528.09"
    },
    {
      "Name": "Khandachakra",
      "Nepali": "खाँडाचक्र",
      "District": "Kalikot",
      "Province": "Karnali",
      "Population_2011": "20,288",
      "Area_km2": "133.29"
    },
    {
      "Name": "Chhayanath Rara",
      "Nepali": "छायाँनाथ रारा",
      "District": "Mugu",
      "Province": "Karnali",
      "Population_2011": "20,078",
      "Area_km2": "480.67"
    },
    {
      "Name": "Myanglung",
      "Nepali": "म्याङलुङ",
      "District": "Terathum",
      "Province": "Province No. 1",
      "Population_2011": "19,659",
      "Area_km2": "100.21"
    },
    {
      "Name": "Chandannath",
      "Nepali": "चन्दननाथ",
      "District": "Jumla",
      "Province": "Karnali",
      "Population_2011": "19,047",
      "Area_km2": "102.03"
    },
    {
      "Name": "Budhinanda",
      "Nepali": "बुढीनन्दा",
      "District": "Bajura",
      "Province": "Sudurpashchim",
      "Population_2011": "18,776",
      "Area_km2": "232.48"
    },
    {
      "Name": "Rainas",
      "Nepali": "रार्इनास",
      "District": "Lamjung",
      "Province": "Gandaki",
      "Population_2011": "18,527",
      "Area_km2": "71.97"
    },
    {
      "Name": "Tribeni",
      "Nepali": "त्रिवेणी",
      "District": "Bajura",
      "Province": "Sudurpashchim",
      "Population_2011": "18,363",
      "Area_km2": "170.32"
    },
    {
      "Name": "Dharmadevi",
      "Nepali": "धर्मदेवी",
      "District": "Sankhuwasabha",
      "Province": "Province No. 1",
      "Population_2011": "18,235",
      "Area_km2": "132.82"
    },
    {
      "Name": "Panchkhapan",
      "Nepali": "पाँचखपन",
      "District": "Sankhuwasabha",
      "Province": "Province No. 1",
      "Population_2011": "17,521",
      "Area_km2": "148.03"
    },
    {
      "Name": "Laligurans",
      "Nepali": "लालिगुराँस",
      "District": "Terathum",
      "Province": "Province No. 1",
      "Population_2011": "16,970",
      "Area_km2": "90.27"
    },
    {
      "Name": "Badimalika",
      "Nepali": "बडीमालिका",
      "District": "Bajura",
      "Province": "Sudurpashchim",
      "Population_2011": "16,818",
      "Area_km2": "276"
    },
    {
      "Name": "Raskot",
      "Nepali": "रास्कोट",
      "District": "Kalikot",
      "Province": "Karnali",
      "Population_2011": "16,272",
      "Area_km2": "59.73"
    },
    {
      "Name": "Tilagupha",
      "Nepali": "तिलागुफा",
      "District": "Kalikot",
      "Province": "Karnali",
      "Population_2011": "15,766",
      "Area_km2": "262.56"
    },
    {
      "Name": "Jiri",
      "Nepali": "जिरी",
      "District": "Dolakha",
      "Province": "Province No. 3",
      "Population_2011": "15,515",
      "Area_km2": "211.27"
    },
    {
      "Name": "Madi",
      "Nepali": "मादी",
      "District": "Sankhuwasabha",
      "Province": "Province No. 1",
      "Population_2011": "14,470",
      "Area_km2": "110.1"
    },
    {
      "Name": "Tripura Sundari",
      "Nepali": "त्रिपुरासुन्दरी",
      "District": "Dolpa",
      "Province": "Karnali",
      "Population_2011": "10,104",
      "Area_km2": "393.54"
    },
    {
      "Name": "Thuli Bheri",
      "Nepali": "ठूली भेरी",
      "District": "Dolpa",
      "Province": "Karnali",
      "Population_2011": "8,370",
      "Area_km2": "421.34"
    }
  ]